"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.essComponentsFactory = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const authored_evidence_1 = require("../../../composite/evidence/authored-evidence/authored-evidence");
const evidence_1 = require("../../../composite/evidence/evidence");
const components_fields_1 = require("./components-fields");
const components_columns_1 = require("./components-columns");
const lodash_1 = require("lodash");
function essComponentsFactory(url, reportTag) {
    return function Components() {
        const intl = react_intl_1.useIntl();
        const evidence = authored_evidence_1.useAuthoredEvidence({
            identifier: 'ESS_COMPONENTS',
            apiProps: {
                url,
            },
            tableProps: {
                columns: components_columns_1.useColumns(),
                tableName: intl.formatMessage({
                    id: 'ESS_COMPONENTS_TABLE_TITLE',
                    defaultMessage: 'Komponenty',
                }),
                reportTag,
            },
            detailProps: {
                FieldsComponent: components_fields_1.ComponentsFields,
                toolbarProps: {
                    showButton: lodash_1.stubFalse,
                },
            },
        });
        return react_1.default.createElement(evidence_1.Evidence, Object.assign({}, evidence));
    };
}
exports.essComponentsFactory = essComponentsFactory;
//# sourceMappingURL=components.js.map